(ns iris.components.chip
  (:require
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.chip :as $chip]))



(defn chip [label & {:keys [label-len css-class stop-propagation? on-click on-click-remove children]
                     :or {stop-propagation? true
                          on-click #(println "click")}
                     :as opts}]
  [:div {:on-click (fn [e]
                     (when stop-propagation? (.stopPropagation e))
                     (on-click))
         :class (str $chip/$chip (if css-class (str " " css-class) ""))}
   [:span {:class $chip/$label :title label} (if (and label-len (> (count label) label-len)) (str (subs label 0 label-len) "...") label)]
   (when children children)
   (when on-click-remove
     [:span {:class $chip/$remove-btn
             :on-click (fn [e]
                         (when stop-propagation? (.stopPropagation e))
                         (on-click-remove))}
      [:i {:class "glyphicon glyphicon-remove"}]])])